import React, { Component, PropTypes } from 'react';
import { GroupStore, CategoryStore, SettingsStore } from 'stores';
import {
  CategoryActions,
  CourseActions,
  InvitationActions,
  GroupActions,
  InviteActions,
  StudentActions,
  SettingsActions,
  UserActions
} from 'actions';
import SimpleOverview from 'components/Widgets/SimpleOverview';
import CourseDetailActions from 'actions/CourseDetail';
import InvitationDetailActions from 'actions/InvitationDetail';
import CourseDetailStore from 'stores/CourseDetail';
import {
  DatePicker,
  Toolbar,
  Styles,
  ToolbarGroup,
  ToolbarTitle,
  RaisedButton,
  Dialog,
  List,
  ListItem,
  TextField,
  Toggle
} from 'material-ui';
import InvitationDetailStore from 'stores/InvitationDetail';
import Message from 'services/Message';
import ScrollableContainer from 'components/ScrollableContainer';
import { mixin, RefluxMixin, Authorizer } from 'Util';
import * as Icons from 'components/Material/SvgIcons';
import Cover from 'components/Material/Cover';
import ToolbarIconButton from 'components/Material/ToolbarIconButton';
import StudentSelector from 'components/StudentSelector';
import GroupSelector from 'components/GroupSelector';
import InviteeAdder from 'components/InviteeAdder';
import DialogPortal from 'components/DialogPortal';
import MaterialDropDown from 'components/Material/DropDown';
import { FormattedMessage } from 'react-intl';
import CourseDiplomaEditor from 'containers/CourseDiplomaEditor';
import CourseDripContentEditor from 'containers/CourseDripContentEditor';
import CourseQuizContentEditor from 'containers/CourseQuizContentEditor';

import StudentOverview from 'components/Student/StudentOverview';
import InvitationOverview from 'components/Invitation/InvitationOverview';
import { getStudents, getInvitations } from 'selectors/courseDetail';
import { TagSelector } from 'components/Tags';
import Overview from 'components/Widgets/Overview';
import { Units, Colors } from 'Css';
import { DropDown } from 'components/DropDown';
import Ozitor from 'components/Widgets/Ozitor';
import { translate as _l } from 'oxygen-i18n';
const { Spacing } = Styles;

addTranslations({
  ['en-US']: {
    'customExport': 'Would you like the report to be sent to a third party? (leave empty if not)'
  },
  ['sv-SE']: {
    'customExport': 'Vill du att rapporten ska skickas till en tredjepart? (annars lämna fältet tomt)'
  }
})

const css = oxygenCss({
  buttonContainer: {
    position: 'relative',
    textAlign: 'right',
    padding: Units.base,
    '>DIV': {
      marginLeft: Units.base
    }
  },
  toggle: {
    marginTop: '15px',
    maxWidth: '250px',
  }
});

const minDate = new Date();
const maxDate = new Date();
maxDate.setFullYear(maxDate.getFullYear() + 2);

export default class CourseDetail extends mixin(
  RefluxMixin,
  Authorizer,
  Component
) {
  state = {
    selectedStudent: {},
    selectedInvitation: {},
    selectedSpecificInvitation: [],
    selectedGroup: {},
    accessTime: 'threeMonths',
    invitees: [],
    userIds: {},
    value: '',
    toggleValue: 'Tasks',
  };

  handleChange = (e) => {
    this.setState({ value: e.target.value})
  }

  toggleChange = (e, isInputChecked) => {
    this.setState({ toggleValue: isInputChecked ? 'Quizzes' : 'Tasks' })
  }

  static contextTypes = {
    getIntlMessage: PropTypes.func,
    muiTheme: PropTypes.object
  };

  constructor(props, context) {
    super(props, context);
    this.accessTimes = {
      oneMonth: context.getIntlMessage('invite.oneMonth'),
      threeMonths: context.getIntlMessage('invite.threeMonths'),
      sixMonths: context.getIntlMessage('invite.sixMonths'),
      oneYear: context.getIntlMessage('invite.oneYear'),
      twoYears: context.getIntlMessage('invite.twoYears')
    };
    this.menuItems = [
      { payload: null, text: context.getIntlMessage('invite.chooseAccessTime') }
    ];
    Object.keys(this.accessTimes).forEach(time => {
      this.menuItems.push({ payload: time, text: this.accessTimes[time] });
    });
  }

  listenToStores() {
    this.listenToStore(SettingsStore, 'settings');
    this.listenToStore(GroupStore, 'group');

    this.listenToStoreWithMapper(CourseDetailStore, state => {
      return {
        studentsLoading: state.students.loading,
        studentsPrevDisabled: state.students.pageStart < 1,
        studentsNextDisabled: false,
        pageStartStudents: state.students.pageStart,
        pageLengthStudents: state.students.pageLength,
        totalStudents: state.totalStudents,
        students: getStudents(state),
        ...this.mapActions({
          prevStudents: CourseDetailActions.prevStudents,
          nextStudents: CourseDetailActions.nextStudents,
          filterStudents: CourseDetailActions.filterStudents,
          filterStudentsByStatus: CourseDetailActions.filterStudentsByStatus,
        })
      };
    });
    this.listenToStoreWithMapper(InvitationDetailStore, state => {
      return {
        invitationsLoading: state.invitations.loading,
        invitationsPrevDisabled: state.invitations.pageStart < 1,
        invitationsNextDisabled: false,
        pageStartInvitations: state.invitations.pageStart,
        pageLengthInvitations: state.invitations.pageLength,
        totalInvitations: state.totalInvitations,
        invitations: getInvitations(state),
        ...this.mapActions({
          prevInvitations: InvitationDetailActions.prevInvitations,
          nextInvitations: InvitationDetailActions.nextInvitations
        })
      };
    });

    this.listenToStoreWithMapper(CategoryStore, state => {
      return {
        categories: state.list
      };
    });
  }

  componentDidMount() {
    let { course } = this.props;

    CategoryActions.initCategories();

    CourseDetailActions.read(course.id);
    InvitationDetailActions.read(course.id);

    CourseDetailActions.countStudents(course.id);
    InvitationDetailActions.countInvitations(course.id);

    CategoryActions.initCategories();
    GroupActions.findByCourseId(course.id);
  }

  componentWillMount() {
    if (super.componentWillMount) {
      super.componentWillMount();
    }
    SettingsActions.read();
  }

  removeStudent(student) {
    this.setState({ selectedStudent: student });
    this.refs.removeStudentDialog.show();
  }
  _onRemoveStudentConfirm() {
    let { course } = this.props;
    StudentActions.removeFromCourse(
      this.props.course.id,
      this.state.selectedStudent.id
    );
    StudentActions.findByCourseId(course.id);
    this.state.totalStudents--;
    CourseDetailActions.read(course.id);
    this.refs.removeStudentDialog.dismiss();
  }

  removeInvitation(invitation) {
    this.setState({ selectedInvitation: invitation });
    this.refs.removeInvitationDialog.show();
  }

  resendInvitation(invitation) {
    this.setState({ selectedInvitation: invitation });
    this.refs.resendInvitationDialog.show();
  }

  resendSpecificInvitation(invitation) {
    if (!invitation.clicked) {
      invitation.clicked = true;
      this.state.selectedSpecificInvitation.push(invitation);
    } else {
      invitation.clicked = false;
      var index = this.state.selectedSpecificInvitation.indexOf(invitation);
      this.state.selectedSpecificInvitation.splice(index, 1);
    }
  }

  resendInvitationAll(invitations) {
    this.setState({ selectedInvitation: invitations });
    this.refs.resendInvitationAllDialog.show();
  }

  resendInvitationChosen(invitations) {
    if (this.state.selectedSpecificInvitation.length > 0) {
      this.refs.resendInvitationChosenDialog.show();
    } else {
      Message.info(this.context.getIntlMessage('invitation.notChosen'));
    }
  }

  _onResendInvitationChosenConfirm() {
    InvitationActions.resend(
      this.state.selectedSpecificInvitation.map(invitation => {
        return invitation.id;
      })
    );
    // this.state.selectedSpecificInvitation.map( invitation => { return invitation.clicked = true });
    Message.info(this.context.getIntlMessage('invitation.resent'));
    this.refs.resendInvitationChosenDialog.dismiss();
    InvitationActions.findByCourseId(this.props.course.id);
  }

  _onResendInvitationConfirm() {
    InvitationActions.resend(this.state.selectedInvitation.id);
    this.state.selectedInvitation.clicked = true;
    Message.info(this.context.getIntlMessage('invitation.resent'));
    this.refs.resendInvitationDialog.dismiss();
    InvitationActions.findByCourseId(this.props.course.id);
  }

  _onResendInvitationAllConfirm() {
    InvitationActions.resend(
      this.state.selectedInvitation.map(invitation => {
        return invitation.id;
      })
    );
    this.state.selectedInvitation.map(invitation => {
      return (invitation.clicked = true);
    });
    Message.info(this.context.getIntlMessage('invitation.allResent'));
    this.refs.resendInvitationAllDialog.dismiss();
    InvitationActions.findByCourseId(this.props.course.id);
  }

  _onRemoveInvitationConfirm() {
    InvitationActions.delete(this.state.selectedInvitation.id);
    InvitationActions.findByCourseId(this.props.course.id);
    CourseDetailActions.read(this.props.course.id);
    this.refs.removeInvitationDialog.dismiss();
    this.state.totalInvitations--;
    InvitationActions.findByCourseId(this.props.course.id);
    CourseDetailActions.read(this.props.course.id);
  }

  removeGroup(groupId) {
    this.setState({ selectedGroup: group });
    this.refs.removeGroupDialog.show();
  }

  _onRemoveGroupConfirm() {
    GroupActions.removeFromCourse(
      this.props.course.id,
      this.state.selectedGroup.id
    );
    this.refs.removeGroupDialog.dismiss();
  }

  closeDetail() {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  addStudents() {
    this.refs.addStudentsDialog.show();
  }

  changeAccessTime(event, selectedIndex, menuItem) {
    this.setState({ accessTime: menuItem.payload });
  }

  _selectStudents = userIds => {
    this.setState({ userIds });
  };

  _closeAddStudentsDialog = () => {
    this.refs.addStudentsDialog.dismiss();
  };

  changeCategory = categorySlug => {
    const { course } = this.props;
    CourseActions.setCategory(course.id, [categorySlug]);
  };

  createAddStudentsDialog() {
    const { getIntlMessage } = this.context;
    const { userIds } = this.state;
    const { menuItems } = this;
    const selectedIndex = menuItems.findIndex(
      item => item.payload === this.state.accessTime
    );

    return (
      <Dialog ref="addStudentsDialog">
        <MaterialDropDown
          onChange={::this.changeAccessTime}
          label={this.context.getIntlMessage('invite.accessTime')}
          ref="courseAccessTime"
          selectedIndex={selectedIndex}
          menuItems={menuItems}
        />
        <StudentSelector
          ref="studentSelector"
          onSelect={this._selectStudents}
        />
        <div className={css.buttonContainer}>
          <RaisedButton
            label={this.context.getIntlMessage('Cancel')}
            onTouchTap={this._closeAddStudentsDialog}
          />
          <RaisedButton
            secondary
            disabled={Object.keys(userIds).length < 1}
            label={getIntlMessage('Invite')}
            onTouchTap={this._addStudentsConfirm.bind(this)}
          />
        </div>
      </Dialog>
    );
  }

  _addStudentsConfirm() {
    let userIds = Object.keys(this.refs.studentSelector.getSelected()).map(id =>
      parseInt(id, 10)
    );
    let accessTime = this.state.accessTime;
    let courseIds = [this.props.course.id];
    InviteActions.inviteByUserIds(userIds, courseIds, accessTime, () => {
      Message.info(this.context.getIntlMessage('course.studentsInvited'));
      this.refs.addStudentsDialog.dismiss();
      this.state.totalStudents++;
      StudentActions.findByCourseId(this.props.course.id);
      CourseDetailActions.read(this.props.course.id);
    });
  }

  inviteStudents() {
    this.refs.inviteStudentsDialog.show();
  }

  _closeInvitesDialog = () => {
    this.refs.inviteStudentsDialog.dismiss();
  };

  _handleInviteesChange = invitees => {
    this.setState({ invitees });
  };

  createInviteStudentsDialog() {
    const { getIntlMessage } = this.context;
    const { invitees } = this.state;
    const { menuItems } = this;
    const selectedIndex = menuItems.findIndex(
      item => item.payload === this.state.accessTime
    );
    return (
      <Dialog
        ref="inviteStudentsDialog"
        dismissOnClickAway
        autoDetectWindowHeight
        autoScrollBodyContent
      >
        <MaterialDropDown
          onChange={::this.changeAccessTime}
          label={this.context.getIntlMessage('invite.accessTime')}
          ref="courseAccessTime"
          selectedIndex={selectedIndex}
          menuItems={menuItems}
        />
        <InviteeAdder
          ref="invitees"
          standAlone
          onChange={this._handleInviteesChange}
        />
        <div className={css.buttonContainer}>
          <RaisedButton
            label={this.context.getIntlMessage('Cancel')}
            onTouchTap={this._closeInvitesDialog}
          />
          <RaisedButton
            secondary
            disabled={invitees.length < 1}
            label={getIntlMessage('Invite')}
            onTouchTap={this._inviteStudentsConfirm.bind(this)}
          />
        </div>
      </Dialog>
    );
  }

  _inviteStudentsConfirm() {
    const { invitees: emails, accessTime } = this.state;
    InviteActions.inviteByEmails(emails, [this.props.course.id], accessTime, () => {
      Message.info(this.context.getIntlMessage('course.studentsInvited'));
      this.refs.inviteStudentsDialog.dismiss();
      this.state.totalInvitations++;
      InvitationActions.findByCourseId(this.props.course.id);
      CourseDetailActions.read(this.props.course.id);
    });
  }

  addGroups() {
    this.refs.addGroupsDialog.show();
  }

  createAddGroupsDialog() {
    let actions = [
      { text: this.context.getIntlMessage('Cancel') },
      {
        text: this.context.getIntlMessage('Add'),
        onTouchTap: this._addGroupsConfirm.bind(this),
        ref: 'submit'
      }
    ];

    return (
      <Dialog
        ref="addGroupsDialog"
        actions={actions}
        actionFocus="submit"
        dismissOnClickAway={true}
        autoDetectWindowHeight={true}
        autoScrollBodyContent={true}
      >
        {this.context.getIntlMessage('invite.accessTime')} :{' '}
        <DatePicker
          style={{ display: 'inline-block' }}
          ref="endDate"
          maxDate={maxDate}
          minDate={minDate}
          hintText={this.context.getIntlMessage('invite.chooseEndDate')}
        />
        <GroupSelector ref="groupSelector" />
      </Dialog>
    );
  }

  _addGroupsConfirm() {
    let circleIds = Object.keys(this.refs.groupSelector.getSelected()).map(id =>
      parseInt(id, 10)
    );
    let endDate = this.refs.endDate.getDate();
    let courseIds = [this.props.course.id];
    InviteActions.inviteByCircleIds(circleIds, courseIds, endDate, () => {
      Message.info(this.context.getIntlMessage('course.groupsInvited'));
      this.refs.addGroupsDialog.dismiss();
      GroupActions.findByCourseId(this.props.course.id);
    });
  }

  addTag = tagName => {
    CourseActions.addTag(this.props.course.id, tagName);
  };

  deleteTag = tagName => {
    CourseActions.removeTag(this.props.course.id, tagName);
  };

  changeDescription = description => {
    CourseActions.update(this.props.course.id, { description });
  };

  updateAccess(item, finDate) {
    UserActions.course(this.props.course.id, item.id, finDate);
    Message.info(this.context.getIntlMessage('course.dateSaved'));
    CourseDetailActions.read(this.props.course.id);
  };

  export = () => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let email = null;
    if(re.test(String(this.state.value).toLowerCase())){
      email = this.state.value;
    }
    StudentActions.export({
      courseIds:[this.props.course.id],
      recipientEmail: email
    });
    this.refs.exportDialog.dismiss()
  };

  exportStatistic = () => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let email = null;
    if(re.test(String(this.state.value).toLowerCase())){
      email = this.state.value;
    }
    const { toggleValue } = this.state;

    StudentActions.exportStatistic({
      id:this.props.course.id,
      recipientEmail: email,
      mode: toggleValue === 'Quizzes' ? 'quiz' : 'task',
    });
    this.refs.exportStatisticDialog.dismiss()
  };

  render() {
    const {
      studentsLoading,
      students,
      prevStudents,
      nextStudents,
      filterStudents,
      filterStudentsByStatus,
      studentsPrevDisabled,
      studentsNextDisabled,
      invitationsLoading,
      invitations,
      prevInvitations,
      nextInvitations,
      invitationsPrevDisabled,
      invitationsNextDisabled,
      pageStartStudents,
      pageLengthStudents,
      pageStartInvitations,
      pageLengthInvitations,
      totalStudents,
      totalInvitations,
      settings,
      toggleValue,
    } = this.state;

    let course = this.props.course,
      coverImage = course.coverImage,
      backgroundImage = coverImage && coverImage.url,
      addStudentsDialog = this.createAddStudentsDialog(),
      inviteStudentsDialog = this.createInviteStudentsDialog(),
      addGroupsDialog = this.createAddGroupsDialog(),
      removeStudentActions = [
        { text: this.context.getIntlMessage('Cancel') },
        {
          text: this.context.getIntlMessage('Remove'),
          onTouchTap: this._onRemoveStudentConfirm.bind(this),
          ref: 'submit'
        }
      ],
      removeInvitationActions = [
        { text: this.context.getIntlMessage('Cancel') },
        {
          text: this.context.getIntlMessage('Remove'),
          onTouchTap: this._onRemoveInvitationConfirm.bind(this),
          ref: 'submit'
        }
      ],
      resendInvitationActions = [
        { text: this.context.getIntlMessage('Cancel') },
        {
          text: this.context.getIntlMessage('Resend'),
          onTouchTap: this._onResendInvitationConfirm.bind(this),
          ref: 'submit'
        }
      ],
      resendInvitationAllActions = [
        { text: this.context.getIntlMessage('Cancel') },
        {
          text: this.context.getIntlMessage('Resend'),
          onTouchTap: this._onResendInvitationAllConfirm.bind(this),
          ref: 'submit'
        }
      ],
      resendInvitationChosenActions = [
        { text: this.context.getIntlMessage('Cancel') },
        {
          text: this.context.getIntlMessage('Resend'),
          onTouchTap: this._onResendInvitationChosenConfirm.bind(this),
          ref: 'submit'
        }
      ],
      removeGroupActions = [
        { text: this.context.getIntlMessage('Cancel') },
        {
          text: this.context.getIntlMessage('Remove'),
          onTouchTap: this._onRemoveGroupConfirm.bind(this),
          ref: 'submit'
        }
      ],
      exportActions = [
        { text: this.context.getIntlMessage('Cancel') },
        {
          text: this.context.getIntlMessage('Export'),
          onTouchTap: this.export,
          ref: 'submit'
        }
      ],
      exportStatisticActions = [
        { text: this.context.getIntlMessage('Cancel') },
        {
          text: this.context.getIntlMessage('Export'),
          onTouchTap: this.exportStatistic,
          ref: 'submit'
        }
      ];

    const selectedIndex = 0;
    const { categories } = this.state;
    let toolbar = (
      <Toolbar>
        <ToolbarGroup float={'left'} key={0}>
          <ToolbarTitle text={this.props.course.name} />
        </ToolbarGroup>
        <ToolbarGroup float={'right'} key={1}>
          <ToolbarIconButton
            tooltip={this.context.getIntlMessage('group.add')}
            tooltipPosition="bottom-center"
            svgIcon={<Icons.SocialGroupAdd />}
            onTouchTap={this.addGroups.bind(this)}
          />
          <ToolbarIconButton
            tooltip={this.context.getIntlMessage('student.add')}
            tooltipPosition="bottom-center"
            svgIcon={<Icons.SocialPersonAdd />}
            onTouchTap={this.addStudents.bind(this)}
          />
          <ToolbarIconButton
            tooltip={this.context.getIntlMessage('student.inviteNew')}
            tooltipPosition="bottom-center"
            svgIcon={<Icons.ContentMail />}
            onTouchTap={this.inviteStudents.bind(this)}
          />
          <ToolbarIconButton
            tooltip={this.context.getIntlMessage('Close')}
            tooltipPosition="bottom-center"
            svgIcon={<Icons.ContentClear />}
            onTouchTap={this.closeDetail.bind(this)}
          />
          <ToolbarIconButton
            tooltip={this.context.getIntlMessage('export.course')}
            tooltipPosition="bottom-center"
            svgIcon={<Icons.ActionLaunch />}
            onTouchTap={this.refs.exportDialog && this.refs.exportDialog.show}
          />
          <ToolbarIconButton
            tooltip={this.context.getIntlMessage('export.statistic')}
            tooltipPosition="bottom-center"
            svgIcon={<Icons.EditorInsertDriveFile />}
            onTouchTap={this.refs.exportStatisticDialog && this.refs.exportStatisticDialog.show}
          />
        </ToolbarGroup>
      </Toolbar>
    );
 

    let invites = this.state.invitations.sort((a, b) => {
      return new Date(b.expires).getTime() - new Date(a.expires).getTime();
    });

    let selectedSpecificInvitation = this.state.selectedSpecificInvitation;

    let resendButton = null;
    let features = null;
    let hasDiplomas =
      settings.list &&
      settings.list.features &&
      settings.list.features.diplomas === true;
    let hasQuiz =
      settings.list &&
      settings.list.features &&
      settings.list.features.quiz === true;
    let hasDripContent =
      settings.list &&
      settings.list.features &&
      settings.list.features.dripContent === true;

    if (
      settings.list &&
      settings.list.features &&
      settings.list.features.enterpriseStore == true
    ) {
      features = (
        <div>
          <Overview header={this.context.getIntlMessage('Tags')}>
            <div style={{ padding: Spacing.desktopGutterMini * 2 }}>
              <TagSelector
                onAddTag={this.addTag}
                onRemoveTag={this.deleteTag}
                tags={course.tagsMap}
                fullWidth
                padded
              />
            </div>
          </Overview>
          <Overview header={this.context.getIntlMessage('course.category')}>
            <div style={{ padding: Spacing.desktopGutterMini * 2 }}>
              <DropDown
                onChange={this.changeCategory}
                selected={course.categories && course.categories[0]}
                options={categories}
                fullWidth
              />
            </div>
          </Overview>
          <Overview header={this.context.getIntlMessage('Description')}>
            <Ozitor
              style={{
                content: {
                  minHeight: Units.keyline * 2,
                  height: Units.keyline * 2,
                  maxHeight: Units.keyline * 4
                },
                root: {
                  minHeight: 'auto'
                }
              }}
              editable
              onChange={this.changeDescription}
              defaultContent={course.description}
            />
          </Overview>
        </div>
      );
    }

    if (this.state.invitations.length != 0) {
      resendButton = (
        <div>
          <List
            subheader=""
            subheaderStyle={{
              fontSize: 24,
              borderStyle: 'none none solid none',
              borderWidth: '1px',
              borderColor: 'rgba(0, 0, 0, 0.12)'
            }}
          >
            <ListItem disabled>
              <RaisedButton
                style={{ margin: 8 }}
                onTouchTap={this.resendInvitationChosen.bind(this, invitations)}
                label={this.context.getIntlMessage('invitation.chosen')}
              />
              <RaisedButton
                style={{ margin: 8 }}
                onTouchTap={this.resendInvitationAll.bind(this, invitations)}
                label={this.context.getIntlMessage('invitation.resendAll')}
              />
            </ListItem>
          </List>
        </div>
      );
    }

    return (
      <ScrollableContainer header={toolbar} card>
        <Cover image={backgroundImage} />
        <List>
          <ListItem
            disabled
            leftIcon={<Icons.ActionLabel />}
            primaryText={course.name}
          />
          <ListItem
            disabled
            leftIcon={<Icons.ActionFace />}
            primaryText={course.ownerName}
          />
        </List>
        {hasQuiz && <CourseQuizContentEditor course={course} /> }
        {hasDiplomas && <CourseDiplomaEditor course={course} />}
        {hasDripContent && <CourseDripContentEditor course={course} />}

        <StudentOverview
          list={students}
          loading={studentsLoading}
          prevDisabled={studentsPrevDisabled}
          nextDisabled={studentsNextDisabled}
          prev={prevStudents}
          next={nextStudents}
          filter={filterStudents}
          filterByStatus={filterStudentsByStatus}
          onTouchTapRightIcon={this.removeStudent.bind(this)}
          total={totalStudents}
          pageStartStudents={pageStartStudents}
          pageLengthStudents={pageLengthStudents}
          onTouchTap={this.updateAccess.bind(this)}
        />
        {resendButton}

        <InvitationOverview
          list={invites}
          loading={invitationsLoading}
          prevDisabled={invitationsPrevDisabled}
          nextDisabled={invitationsNextDisabled}
          prev={prevInvitations}
          next={nextInvitations}
          onTouchTapRightIcon={this.removeInvitation.bind(this)}
          onTouchTapLeftIcon={this.resendInvitation.bind(this)}
          onCheck={this.resendSpecificInvitation.bind(this)}
          total={totalInvitations}
          pageStartInvitations={pageStartInvitations}
          pageLengthInvitations={pageLengthInvitations}
        />

        {features}
        <SimpleOverview
          items={this.state.group.selection}
          limitToMax={100}
          readable="name"
          title={this.context.getIntlMessage('group.Groups')}
          onTouchTapRightIcon={this.removeGroup.bind(this)}
        />
        <DialogPortal>
          <Dialog
            ref="removeStudentDialog"
            title={this.context.getIntlMessage('student.removeFromCourse')}
            actions={removeStudentActions}
            actionFocus="submit"
            dismissOnClickAway={true}
          >
            <FormattedMessage
              message={this.context.getIntlMessage('student.revokeAccess')}
              student={this.state.selectedStudent.name}
              course={this.props.course.name}
            />
          </Dialog>
          <Dialog
            ref="removeInvitationDialog"
            title={this.context.getIntlMessage('invitation.remove')}
            actions={removeInvitationActions}
            actionFocus="submit"
            dismissOnClickAway={true}
          >
            {this.context.getIntlMessage('invitation.revokeAccess')}
          </Dialog>
          <Dialog
            ref="resendInvitationDialog"
            title={this.context.getIntlMessage('invitation.resend')}
            actions={resendInvitationActions}
            actionFocus="submit"
            dismissOnClickAway={true}
          >
            {this.context.getIntlMessage('invitation.prolongAccess')}
          </Dialog>
          <Dialog
            ref="resendInvitationAllDialog"
            title={this.context.getIntlMessage('invitation.resendAll')}
            actions={resendInvitationAllActions}
            actionFocus="submit"
            dismissOnClickAway={true}
          >
            {this.context.getIntlMessage('invitation.resendAll')}
          </Dialog>
          <Dialog
            ref="resendInvitationChosenDialog"
            title={this.context.getIntlMessage('invitation.chosen')}
            actions={resendInvitationChosenActions}
            actionFocus="submit"
            dismissOnClickAway={true}
          >
            {this.context.getIntlMessage('invitation.chosen')}
          </Dialog>
          <Dialog
            ref="removeGroupDialog"
            title={this.context.getIntlMessage('student.removeFromCourse')}
            actions={removeGroupActions}
            actionFocus="submit"
            dismissOnClickAway={true}
          >
            <FormattedMessage
              message={this.context.getIntlMessage('group.revokeAccess')}
              group={this.state.selectedGroup.name}
              course={this.props.course.name}
            />
          </Dialog>
          <Dialog
            ref="exportDialog"
            title={_l`customExport`}
            actions={exportActions}
            actionFocus="export"
            dismissOnClickAway={true}
          >
            <TextField onChange={this.handleChange} floatingLabelText="" hintText="Email" />
          </Dialog>
          <Dialog
            ref="exportStatisticDialog"
            title={_l`customExport`}
            actions={exportStatisticActions}
            actionFocus="exportStatistic"
            dismissOnClickAway={true}
          >
            <TextField onChange={this.handleChange} floatingLabelText="" hintText="Email" />
            <Toggle
                label={toggleValue}
                onToggle={this.toggleChange}
                toggled={toggleValue === 'Quizzes'}
                className={css.toggle}
            />
          </Dialog>

          {addStudentsDialog}
          {inviteStudentsDialog}
          {addGroupsDialog}
        </DialogPortal>
      </ScrollableContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Course/Detail.js